import UIButton from 'UIComponents/button/UIButton';
import Code from 'UIComponents/elements/Code';
import HR from 'UIComponents/elements/HR';
import UIList from 'UIComponents/list/UIList';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import FormulaActionExplainer from 'automation-ui-action-features/actions/formula/FormulaActionExplainer';
import FormulaActionSummary from 'automation-ui-action-features/actions/formula/FormulaActionSummary';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import { View } from 'foundations-components/components/View';
import { useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const FormulaActionHistoryCard = ({
  action,
  actionLabel,
  actionMetadata,
  contextMap,
  flowObjectTypeId,
  getActionLabelById,
  getActionOutputsForTargetActionById
}) => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const outputValues = contextMap && contextMap.ACTION_OUTPUT_VALUES;
  const renderOutputValue = ({
    fieldKey,
    value
  }) => /*#__PURE__*/_jsxs("span", {
    children: [/*#__PURE__*/_jsx(Code, {
      children: fieldKey
    }), ": ", value]
  }, fieldKey);
  const PopoverContent = () => /*#__PURE__*/_jsx(View, {
    margin: "300",
    as: "div",
    children: /*#__PURE__*/_jsx(FormulaActionExplainer, {
      action: action,
      flowObjectTypeId: flowObjectTypeId,
      getActionLabelById: getActionLabelById,
      getActionOutputsForTargetActionById: getActionOutputsForTargetActionById
    })
  });
  return /*#__PURE__*/_jsx(LogEventRowAction, {
    title: actionLabel,
    content: /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(FormulaActionSummary, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId,
        getActionLabelById: getActionLabelById
      }), /*#__PURE__*/_jsx(UIPopover, {
        Content: PopoverContent,
        onOpenChange: evt => setIsPopoverOpen(evt.target.value),
        open: isPopoverOpen,
        use: "longform",
        children: /*#__PURE__*/_jsx(UIButton, {
          className: "m-left-1",
          onClick: () => setIsPopoverOpen(!isPopoverOpen),
          use: "link",
          children: "Show details"
        })
      }), outputValues && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(HR, {
          distance: "extra-small"
        }), /*#__PURE__*/_jsx(UIList, {
          children: outputValues.map(renderOutputValue)
        })]
      })]
    })
  });
};
export default FormulaActionHistoryCard;